import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';

import { ReactComponent as ChevronSVG } from 'icons/arrow-down-small.svg';

const Dropdown = ({ title, options }) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="mr5 btn-white flex items-center">
          <span>{title}</span>
          <ChevronSVG className="pl2" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="dropdown-menu dropdown-triangle-top">
          {options.map((o) => (
            <Menu.Item key={o.id}>
              <li>
                <a
                  href={o.url}
                  target="_blank"
                  rel="noreferrer"
                  className="dropdown-item"
                >
                  {o.label}
                </a>
              </li>
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default Dropdown;
